import angular from 'angular';

export const componentsModule = angular.module(
  'portainer.nomad.react.components',
  []
).name;
